import FileDownload from 'js-file-download';
import jsToCsv from '../../utils/jsToCsv';
import { operations as toastOperations } from '../../store/toasts';
import { getParticipants as getParticipantsApi } from '../../../core/api/spaces/participants';
import {
  currentClassRoomId,
  classRoomName,
} from '../../../core/selectors/classroom';

const userFields = ['firstName', 'lastName', 'email', 'role'];
const userHeaders = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'e-mail',
  role: 'Role',
};

const exportParticipants = ({ role, sort }) => async (dispatch, getState) => {
  const state = getState();
  const spaceId = currentClassRoomId(state);
  const spaceName = classRoomName(state);

  try {
    // The spaces stack sets 100 to be the default page size.
    // In this case, we want all users, which is okay as we will not save them in Redux.
    const participants = await getParticipantsApi({
      spaceId,
      skip: 0,
      limit: 1000000,
      sort,
      role,
    });

    FileDownload(
      jsToCsv(userFields, participants, userHeaders),
      `participants-${spaceName}.csv`,
      'text/csv;charset=utf-8;'
    );
  } catch (_error) {
    dispatch(
      toastOperations.showToast({
        emoji: '🤔',
        message: 'Oops! We failed to download the list of participants',
      })
    );
  }
};

export default exportParticipants;
